import React, { useState } from "react";
import { Tabs } from "@design-system/Tabs/Tabs";
import { BooleanControl } from "./playgroundControls";
import { SandboxLayout } from "./SandboxLayout";
import { ShowcasePreview } from "./ShowcasePreview";
import styles from "./DatePickerPlayground.module.scss";

const tabItems = [
    { value: "overview", label: "Overview" },
    { value: "details", label: "Details" },
    { value: "settings", label: "Settings" },
] as const;

type TabValue = (typeof tabItems)[number]["value"];

export const TabsPlayground = () => {
    const [activeTab, setActiveTab] = useState<TabValue>("overview");
    const [hasDisabledTab, setHasDisabledTab] = useState(false);
    const [showPanels, setShowPanels] = useState(true);

    return (
        <SandboxLayout
            controls={
                <section>
                    <h2>Features</h2>
                    <div className={styles.booleanGrid}>
                        <BooleanControl
                            label="Disabled tab"
                            checked={hasDisabledTab}
                            onChange={setHasDisabledTab}
                        />
                        <BooleanControl
                            label="Show panels"
                            checked={showPanels}
                            onChange={setShowPanels}
                        />
                    </div>
                </section>
            }
        >
            <ShowcasePreview
                summary={activeTab}
                width="wide"
                output={JSON.stringify(
                    {
                        value: activeTab,
                        disabledTab: hasDisabledTab ? "settings" : null,
                        showPanels,
                    },
                    null,
                    2,
                )}
            >
                <div className={styles.surface}>
                    <Tabs.Root
                        value={activeTab}
                        onValueChange={(value) => {
                            if (value) {
                                setActiveTab(value);
                            }
                        }}
                    >
                        <Tabs.List>
                            {tabItems.map((tab, index) => (
                                <Tabs.Tab
                                    key={tab.value}
                                    value={tab.value}
                                    disabled={hasDisabledTab && index === 2}
                                >
                                    {tab.label}
                                </Tabs.Tab>
                            ))}
                        </Tabs.List>
                        {showPanels
                            ? tabItems.map((tab) => (
                                  <Tabs.Panel key={tab.value} value={tab.value}>
                                      <div className={styles.panelContent}>
                                          {tab.label} panel content
                                      </div>
                                  </Tabs.Panel>
                              ))
                            : null}
                    </Tabs.Root>
                </div>
            </ShowcasePreview>
        </SandboxLayout>
    );
};
